import React from 'react';
import Image from '../../pics'; 

function whychoose() {
  return (
    <div>
         <div className="uk-section">
            <div className="uk-container">

                <div className="uk-child-width-1-2@m uk-grid-small uk-grid-match uk-text-left align-items-center" data-uk-grid>
                    <div className='text-center'>
                        <div className="aboutimg">
                            <img src={Image.WHYUS} alt='domestic courier'/>
                        </div>
                    </div>
                    <div>
                        <div className="uk-card uk-card-body">
                            <p className='uk-text-justify'>
                                <span className='text-primary uk-text-bold'>User-Friendly Platform: </span> Registered customers can easily generate airway bills and manage their shipments through our intuitive online portal.
                            </p>
                            <p className='uk-text-justify'>
                                <span className='text-primary uk-text-bold'>Free Security Measures: </span> We provide complimentary security envelopes, High Quality boxes and tapes for your shipment, ensuring the safety of your goods throughout the journey.
                            </p>
                            <p className='uk-text-justify'>
                                <span className='text-primary uk-text-bold'> Fast & Reliable Service: </span> On-time pickups, real-time tracking, and status updates via SMS and E-mail.
                            </p>
                            <p className='uk-text-justify'>
                                <span className='text-primary uk-text-bold'>Dedicated Support: </span> Our support team is always available to assist you with any queries or concerns, providing personalized assistance to ensure a smooth shipping experience.
                            </p>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
  )
}

export default whychoose